import tw from 'twin.macro';

import HLSVideo from '@/components/HLSVideo';

type IntervieweeVideoContainerProps = {
  src?: string;
  controls?: boolean;
  fullWidth?: boolean;
};

const IntervieweeVideoContainer: React.FC<IntervieweeVideoContainerProps> = (props) => {
  const { src, controls = true, fullWidth } = props;

  if (!src) {
    return (
      <div tw="space-y-2">
        <div tw="flex w-full justify-center">ไม่พบข้อมูลวิดิโอ</div>
      </div>
    );
  }

  return (
    <div tw="gap-2 flex flex-col items-start content-center">
      <HLSVideo src={src} controls={controls} controlsList='nodownload' fullWidth={fullWidth} />
    </div>
  );
};

export default IntervieweeVideoContainer;
